import { create } from 'zustand';

export const useInterfaceStore = create((set) => ({
  config: null,
  setConfig: (config) => {
    set(() => ({
      config,
    }));
  },
  weclapp: null,
  setWeclapp: (weclapp) => {
    set(() => ({
      weclapp,
    }));
  },
  tanss: null,
  setTanss: (tanss) => {
    set(() => ({
      tanss,
    }));
  },
  openRoute: null,
  setOpenRoute: (openRoute) => {
    set(() => ({
      openRoute,
    }));
  },
  llm: null,
  setLLM: (llm) => {
    set(() => ({
      llm,
    }));
  },
}));
